import React, { useState } from 'react'
import { Col, Row, Space } from 'antd'
import PurchaseLogsDrawer from './PurchaseLogsDrawer'
import { PurchaseData } from 'Store/purchase/types'
import { formatDateTime } from 'helpers/format'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import LinkText from 'Components/text/LinkText'

type Props = {
  id?: number
  purchasing_no?: string
  isCreateMode?: boolean
  detail?: PurchaseData
}

const DetailHeader: React.FunctionComponent<Props> = props => {
  const { id = 0, purchasing_no = '', isCreateMode = false, detail } = props

  const [showLogDrawer, setShowLogDrawer] = useState(false)

  const renderTitle = () => {
    return (
      <Row justify="start" gutter={[8, 8]} align="top">
        <Col>
          <Space direction="vertical" size="small">
            <Space size="small" wrap={true}>
              {isCreateMode ? 'เพิ่มใบสั่งซื้อสินค้า' : `เลขที่ใบสั่งซื้อ : ${purchasing_no}`}
              {!isCreateMode && (
                // <Col>
                //   <ActionButton
                //     text=""
                //     icon={<FileDoneOutlined />}
                //     label="ประวัติการแก้ไข"
                //     action="edit"
                //     onClick={() => setShowLogDrawer(true)}
                //   />
                // </Col>
                <Link onClick={() => setShowLogDrawer(true)} className="ttr-history">
                  ประวัติการแก้ไข
                </Link>
              )}
            </Space>
            {!isCreateMode && (
              <Space size="small" wrap={true}>
                <SmallText>สร้างเมื่อ : {formatDateTime(detail?.created_at || '')} |</SmallText>
                <SmallText>แก้ไขล่าสุดเมื่อ : {formatDateTime(detail?.updated_at || '')} </SmallText>
              </Space>
            )}
          </Space>
        </Col>
      </Row>
    )
  }

  const LogsDrawer = (
    <PurchaseLogsDrawer
      isShow={showLogDrawer}
      onClose={() => setShowLogDrawer(false)}
      id={id}
      currentStatus={''}
    />
  )

  return (
    <>
      {renderTitle()}
      {LogsDrawer}
    </>
  )
}

const SmallText = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const Link = styled(LinkText)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

export default DetailHeader
